import { getAction,uploadAction } from '@/api/manage'
/**
 * 因为要求在所有入口页面都要掉是否实名认证的方法
 */
const OpenIdMixin = {

	data() {
		return {
			imgPathList:[],
			videoPathList:[],
			audioPathList:[],
		}
	},
    create(){
	},
	methods: {
		fileChangeImage(el) {
			if (!el.target.files[0].size) return
			this.fileList('image',el.target.files)
			el.target.value = ''
		  },
		  fileChangeVideo(el) {
			if (!el.target.files[0].size) return
			this.fileList('video',el.target.files)
			el.target.value = ''
		  },
		  fileList(type,files) {
			for (var i = 0; i < files.length; i++) {
			  this.fileAdd(type,files[i])
			}
		  },
		  fileAdd(type,file) {
			this.size = this.size + file.size //总大小
			var reader = new FileReader()
			reader.vue = this
			reader.readAsDataURL(file)
			reader.onload = function () {
			  file.src = this.result
			  this.vue.uploadFile(type,file);
			}
		  },
		  deleteImage(index) {
			// this.size = this.size - this.imgList[index].file.size; //总大小
			this.imgPathList.splice(index, 1)
		  },
		  bytesToSize(bytes) {
			if (bytes === 0) return '0 B'
			var k = 1000, // or 1024
			  sizes = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
			  i = Math.floor(Math.log(bytes) / Math.log(k))
			return (bytes / Math.pow(k, i)).toPrecision(3) + ' ' + sizes[i]
		  },
		  dragenter(el) {
			el.stopPropagation()
			el.preventDefault()
		  },
		  dragover(el) {
			el.stopPropagation()
			el.preventDefault()
		  },
		  drop(el) {
			el.stopPropagation()
			el.preventDefault()
			this.fileList(el.dataTransfer.files)
		  },
		  uploadFile(type,file) {
			let url = '/sys/common/upload';
			 let formData = new FormData()
			  formData.append('file',file);
			 uploadAction(url, formData).then((res) => {
			  if(type=='image'){
				this.imgPathList.push(res.message)
			  }else{
				this.videoPathList.push(res.message);
				 this.$nextTick(()=>{
					this.initVideo();
				})
			  }
			   
			}).catch(err=>{
				this.$toast('上传文件超时');
			})
		  },
		  deleteVideo(index) {
			// this.$video(`myVideos${index}`).dispose();
			this.videoPathList.splice(index, 1);
			
		  },
		  clickPz() {
			document.getElementById('upload_video').click()
		  },
		  clickXc() {
			document.getElementById('upload_image').click()
		  },
		  addId(){
		     if(this.videoPathId.length>0){
				let num = this.videoPathId[this.videoPathId.length-1];
				this.videoPathId.push(num+1);
			 }else{
				this.videoPathId.push(0);
			 } 
		
		  },
		  dispatchVideo(){
			for (let index = 0; index < this.videoPathList.length; index++) {                  
				   this.$video(`myVideos${index}`).dispose();
		   }
		 },
		 initVideo(){          
			let elementList=document.querySelectorAll(".video-js");
			this.element=elementList.length;  //videojs 数量赋值
			for (let index = 0; index < elementList.length; index++) { 
			   let id=elementList[index].getAttribute('id');   
				this.$video(id, {
				  autoplay: false, //自动播放
				//   muted:false, // 是否静音,
				  controls: true,//控制条
				//   techOrder: ['html5','flash'],//设置flash播放
				  language: "en",// 初始化语言
				   preload: "auto",// 预加载
				   width:'300',
				   height:'400',
				   // 倍速播放
				   playbackRates: [0.5, 1, 1.5, 2],
				  }, function () {
					this.volume(0);
					//这个地方很重要,一旦你的muted 不起作用 ,就一定要在设置当前的视频回调中设置声音为0
					//this.play(); //这个地方也一样 ,此方法this.play()==autoplay  是有相同的效果
					this.one("playing", function () {         // 监听播放
					   console.log("成功初始化视频");
					});
					
					this.one("error", function (error) {      // 监听错误
						console.error("监听异常",error);
					});
				}); 
			}
		},
		uploadAudio(id){
			let params = {'media_id':id};
			  getAction('/sys/weixin/upload/file/for/mediaid',params)
			  .then((res) => {
				if(res.success){
                    let message = res.message;
				    this.audioPathList.push(message);
				}else{
                   this.$toast(res.message);
				}
				
			  })
			},
	},
	
}

export default OpenIdMixin;
